import { CARD_CLASS } from "../styles";
import { DEMO_ANALYTICS_OBJECT_VALUE } from "../demoObject";

const SELECT_CLASS =
  "w-full appearance-none rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base text-slate-800 shadow-sm focus:border-indigo-300 focus:outline-none focus:ring-4 focus:ring-indigo-200/60 disabled:bg-slate-50";

type Option = { label: string; value: string };

type Props = {
  value: string;
  options: Option[];
  onChange: (value: string) => void;
  loading?: boolean;
};

export default function ObjectSelectCard({ value, options, onChange, loading = false }: Props) {
  const isEmpty = options.length === 0;
  const countLabel = loading ? "Загрузка" : `${options.length} объектов`;

  if (options.length === 1 && options[0].value === DEMO_ANALYTICS_OBJECT_VALUE) {
    return (
      <section className={CARD_CLASS}>
        <div className="rounded-2xl border border-indigo-100 bg-indigo-50/70 p-5">
          <p className="text-sm font-semibold text-indigo-700">Объект размещения</p>
          <p className="mt-1 text-lg font-semibold text-slate-900">{options[0].label}</p>
        </div>
      </section>
    );
  }

  if (options.length === 1) {
    return null;
  }

  return (
    <section className={CARD_CLASS}>
      <div className="relative overflow-hidden rounded-2xl border border-slate-100 bg-gradient-to-br from-slate-50 via-white to-indigo-50/70 p-5">
        <div className="pointer-events-none absolute -right-10 top-0 h-24 w-24 rounded-full bg-indigo-200/40 blur-2xl" />
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <label className="mt-1 block text-lg font-semibold text-slate-900" htmlFor="dashboard-hotel-select">
              Объект размещения
            </label>
            <p className="mt-1 text-sm text-slate-500">
              Выберите объект, чтобы загрузить фильтры и метрики.
            </p>
          </div>
          <span className="inline-flex items-center rounded-full border border-indigo-100 bg-indigo-50 px-3 py-1 text-xs font-semibold text-indigo-700">
            {countLabel}
          </span>
        </div>

        <div className="relative mt-4">
          <select
            id="dashboard-hotel-select"
            className={SELECT_CLASS}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            disabled={loading || isEmpty}
          >
            {isEmpty && <option value="">{loading ? "Загрузка..." : "Нет доступных объектов"}</option>}
            {!isEmpty && <option value="">— Выберите объект —</option>}
            {!isEmpty &&
              options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
          <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-slate-400">
            ▾
          </span>
        </div>
      </div>
    </section>
  );
}
